import { SET_PICS, SET_PICS_LOADING } from '../actions/types'

const initialState = {
    fpics : [],
    loading : false
}

export default (state = initialState, action) => {
    switch(action.type){
        case SET_PICS_LOADING :
            return { ...state, loading : action.payload}
        case SET_PICS : 
            return { ...state, fpics : action.payload}
        default : 
            return state
    }
}